import { DataRequirements } from '../data.requirements';
import * as i0 from "@angular/core";
import * as i1 from "../mappers/gift-card-list.mapper";
import * as i2 from "../data.requirements";
export class GiftCardListUseCase {
    constructor(mapper, data) {
        this.mapper = mapper;
        this.data = data;
    }
    run() {
        return this.data.getAllGiftCards().pipe(this.mapper.map);
    }
}
GiftCardListUseCase.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GiftCardListUseCase_Factory() { return new GiftCardListUseCase(i0.ɵɵinject(i1.GiftCardListMapper), i0.ɵɵinject(i2.DataRequirementsInjectionToken)); }, token: GiftCardListUseCase, providedIn: "root" });
